


import {
  defineComponent,
  PropType,
  onMounted,
  computed,
  reactive,
} from '@vue/composition-api';
import type { ExternalReportAbility } from '@/models/externalReports/externalReportAbility';
import type {
  EmergencyResponseTeamReportCreateParams,
} from '@/models/apis/externalReports/emergencyResponseTeam/emergencyResponseTeamReportRequest';
import type {
  EmergencyResponseTeamReportCar,
  EmergencyResponseTeamReport,
} from '@/models/externalReports/emergencyResponseTeam/spEmergencyResponseTeamReport';
import type {
  ExternalReportsLabelSp,
  ExternalReportSettings,
} from '@/models/apis/externalReports/external_report_settings';
import { useRequestGuard } from '@/composables/useRequestGuard';
import emergencyResponseTeamReportApi from '@/apis/externalReports/emergencyResponseTeam/emergency_response_team_report';
import emergencyResponseTeamCarApi from '@/apis/externalReports/emergencyResponseTeam/emergency_response_team_car';
import useSpeech from '@/composables/useSpeech';

interface DepartureState {
  hanDisplayName: string;
  showConfirmBaseDepartureModal: boolean;
  emergencyResponseTeamReport: EmergencyResponseTeamReport;
}
export default defineComponent({
  props: {
    emergencyResponseTeamCar: {
      type: Object as PropType<EmergencyResponseTeamReportCar>,
      required: true,
    },
    externalReportAbility: {
      type: Object as PropType<ExternalReportAbility>,
      required: true,
    },
    userSettings: {
      type: Object as PropType<ExternalReportSettings>,
      required: true,
    },
  },
  emits: ['startWorking', 'showErrorOnCommon'],
  setup(props, { emit }) {
    const state = reactive<DepartureState>({
      hanDisplayName: '',
      showConfirmBaseDepartureModal: false,
      emergencyResponseTeamReport: props.emergencyResponseTeamCar.report,
    });
    const { doRequest, isRequesting } = useRequestGuard((errorMessage) => {
      emit('showErrorOnCommon', errorMessage);
    });
    const { doSpeech } = useSpeech();
    const spLabels = computed<ExternalReportsLabelSp>(() => {
      return props.userSettings.sp;
    });

    const startWorking = async(): Promise<void> => {
      if (isRequesting.value) return;

      state.showConfirmBaseDepartureModal = false;
      await createEmergencyResponseTeamReport();
      doSpeech(spLabels.value.message.confirm_departure);
      emit('startWorking', props.userSettings.choices.status.working.key, state.emergencyResponseTeamReport);
    };

    const createEmergencyResponseTeamReport = async(): Promise<void> => {
      const params: EmergencyResponseTeamReportCreateParams = {
        car_id: props.emergencyResponseTeamCar.id,
        base_departure_ts: new Date(),
        operation_start_ts: new Date(),
        han_name: state.hanDisplayName,
      };
      await doRequest(async() => {
        state.emergencyResponseTeamReport = await emergencyResponseTeamReportApi.createEmergencyResponseTeamReport(params);
        await emergencyResponseTeamCarApi.updateReportId(props.emergencyResponseTeamCar.id, {
          current_report_id: state.emergencyResponseTeamReport.id,
        });
      }, '走行開始に失敗しました。再度操作を行ってください');
    };

    onMounted(() => {
      if (!props.externalReportAbility || !props.externalReportAbility.han_name) return;

      state.hanDisplayName = props.externalReportAbility.han_name;
    });

    return {
      state,
      isRequesting,
      spLabels,
      startWorking,
    };
  },
});
